import type { IconComponent } from '@/types';
import { IconContainer } from '../icon-container';

interface FloatingCardProps {
  icon: IconComponent;
  title: string;
  onClick: () => void;
}

/**
 * Карточка быстрого действия — белая с иконкой в accent-круге и текстом
 */
export function FloatingCard({ icon, title, onClick }: FloatingCardProps): JSX.Element {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-3 rounded-[var(--radius)] bg-[var(--card)] p-3 shadow-[var(--shadow)] active:scale-95 transition-transform w-full text-left"
    >
      <IconContainer icon={icon} variant="accent" size="large" className="w-10 h-10" />
      <span className="text-[var(--text-sm)] font-medium text-[var(--foreground)] leading-tight">
        {title}
      </span>
    </button>
  );
}